import { render, staticRenderFns } from "./WebPolicySideNav.vue?vue&type=template&id=551bab34&scoped=true&"
import script from "./WebPolicySideNav.vue?vue&type=script&lang=js&"
export * from "./WebPolicySideNav.vue?vue&type=script&lang=js&"
import style0 from "./WebPolicySideNav.vue?vue&type=style&index=0&id=551bab34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551bab34",
  null
  
)

export default component.exports